import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-input',
  styleUrls: ['form-input.component.scss'],
  template: `
    <mat-form-field floatPlaceholder="auto" class="w-100">
      <mat-label>{{ to.label }}</mat-label>
      <input
        type="{{ props.number === true ? 'number' : '' }}"
        min="{{ props.min }}"
        max="{{ props.max }}"
        attr.maxlength="{{ props.maxLength ? props.maxLength : '' }}"
        matInput
        [placeholder]="props.placeholder || props.label"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [required]="props.required"
        (change)="props.change ? props.change(field, formControl) : ''"
        (blur)="replaceChar($event)"
        (keypress)="
          props.number && ($event.charCode < 48 || $event.charCode > 57)
            ? $event.preventDefault()
            : null
        "
        (wheel)="$event.preventDefault()"
      />
      @if (props.help) {
        <span
          matTooltip="{{ props.help }}"
          aria-label="help"
          tabindex="0"
          [matTooltipPosition]="'above'"
          [matTooltipClass]="'rb-tooltip'"
        >
          <mat-icon class="col-1 help-icon"> help </mat-icon>
        </span>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error> This field is required </mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-form-field>
  `,
  imports: [
    FormlyModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyCustomInputComponent extends FieldType {
  replaceChar(ev): void {
    if (
      this.formControl.value?.includes('|') &&
      this.field.props.context?.type !== 'unitProfile'
    ) {
      this.formControl.setValue(this.formControl.value.replaceAll('|', '¦'));
    }
  }
}
